<template>
    <div class="first-visit">
        <div class="van-hairline--top-bottom information-title" @click="toVisit">
            <img class="title_icon" src="./img/icon_1.png" alt="">
            <span>客服首次回访信息</span>
            <Button size="mini" class="check">查看</Button>
        </div>
    </div>
</template>
<script>
    import {Button} from 'vant'
    export default {
        props: {
            orderId: String,
        },
        methods: {
            toVisit() {
                window.location.href = './visitDetails.html?id=' + this.orderId
            }
        },
        components: { Button }
    }

</script>
<style lang="scss" scoped>
    .first-visit {
        .information-title {
            display: flex;
            align-items: center;
            padding: 20px 16px;
            font-size: 17px;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);

            .title_icon {
                width: 16px;
                margin-right: 10px;
            }
            .check {
                margin-left: 10px;
                background:rgba(243,245,249,1);
                border-radius:10px;
            }
        }
    }
</style>
